import React, {useState} from 'react';
import {Box, Typography, Tabs, Tab} from '@mui/material';
import PartnerDashboardShell from '../components/PartnerDashboard.comp';
import ProfileTab from '../tabs/RiskProfile.tab';
import OverviewTab from '../tabs/RiskOverview.tab';
import CyberRiskFlagsTab from '../tabs/CyberRiskFlags.tab';
import DataQualityTab from '../tabs/DataQuality.tab';

const NAVY   = '#052F44';
const ORANGE = '#FF6900';
const TEAL   = '#1B6B55';

/* ── Per-tab metadata ───────────────────────────────────────────── */
const TAB_LABELS      = ['Overview', 'Cyber-Risk Flags', 'Data Quality and Freshness'];
const TAB_SUBTITLES   = [
    'Which cyber risks are most prevalent, and which need action first?',
    'Which countries or schools need safeguarding or prevention support first?',
    'Which deployments have data-quality issues that limit reporting, comparison, or impact claims?',
];
const TAB_TITLES      = ['Risk & Data Quality Overview', 'Cyber-Risk Flags', 'Data Quality and Freshness'];
const TAB_BREADCRUMBS = ['Overview', 'Cyber-Risk Flags', 'Data Quality and Freshness'];

/* ── Main page ──────────────────────────────────────────────────── */
const RiskQualityPage = () => {
    const [activeTab, setActiveTab] = useState(0);

    // Map the active rendered tab index to its metadata array index.
    // 'Cyber Risk Flags' is the only enabled tab (index 0 in rendered tabs, index 1 in metadata).
    const enabledIndices = [0];
    const currentMetaIndex = enabledIndices[activeTab] ?? 1;

    return (
        <PartnerDashboardShell
            tabs={
                <Tabs
                    value={activeTab}
                    onChange={(_, v) => setActiveTab(v)}
                    TabIndicatorProps={{style: {backgroundColor: ORANGE}}}
                    sx={{
                        borderBottom: '1px solid #E5E7EB',
                        mb: 1,
                        '& .MuiTab-root': {
                            textTransform: 'none',
                            fontWeight: 600,
                            fontSize: '14px',
                            color: '#6A7282',
                            px: 2,
                        },
                        '& .Mui-selected': {color: `${ORANGE} !important`},
                    }}
                >
                    <Tab label="Overview"/>
                    <Tab label="By Country & School"/>
                    {/* <Tab label="Data Quality and Freshness"/> */}
                </Tabs>
            }
        >
            {/* Title */}
            <Typography sx={{fontSize: '23px', fontWeight: 800, color: NAVY, mb: 0.5, mt: 1.5}}>
                {activeTab === 0 && 'Cyber Risks'}
                {activeTab === 1 && 'Cyber Risks'}
            </Typography>

            {/* Decision question */}
            <Box sx={{display: 'flex', alignItems: 'baseline', gap: 1, mb: 3}}>
                {/*<Typography sx={{fontSize: '14px', fontWeight: 700, color: NAVY, flexShrink: 0}}>*/}
                {/*    Decision question:*/}
                {/*</Typography>*/}
                <Typography sx={{fontSize: '14px', fontStyle: 'italic', color: '#4B5563'}}>
                    {TAB_SUBTITLES[currentMetaIndex]}
                </Typography>
            </Box>

             {activeTab === 0 && <ProfileTab/>}
            {/*{activeTab === 1 && <CyberRiskFlagsTab/>}
            {activeTab === 2 && <DataQualityTab/>} */}
            {activeTab === 1 && <CyberRiskFlagsTab/>}

        </PartnerDashboardShell>
    );
};

export default RiskQualityPage;
